<template>
    <div>
        <b-row>
            <b-col cols="9">
                <strong>Reden</strong>
            </b-col>
            <b-col cols="2">
                <strong>Probeer automatisch opnieuw toe te wijzen</strong>
            </b-col>
            <b-col cols="1"/>
        </b-row>

        <Draggable v-model="value"
                   :group="randomGroupId"
                   @end="$emit('input', value)"
        >
            <b-row v-for="(unableToShipReason, index) in value" :key="index" class="mt-3 draggable">
                <b-col cols="9">
                    <font-awesome-icon icon="grip-vertical" class="draggable-icon d-inline-block text-info mr-2"/>
                    <b-input v-model="unableToShipReason.description" size="sm" :disabled="disabled" class="d-inline-block" style="width:calc(100% - 20px);"/>
                </b-col>
                <b-col cols="2">
                    <b-checkbox switch v-model.trim="unableToShipReason.isAutoReassignable" size="lg" :disabled="disabled"/>
                </b-col>
                <b-col cols="1">
                    <b-button @click="removeReason(index)" variant="danger" size="sm" :disabled="disabled">
                        <font-awesome-icon icon="trash"/>
                    </b-button>
                </b-col>
            </b-row>
        </Draggable>

        <b-row class="mt-3">
            <b-col cols="9">
                <form @submit.prevent="addReason">
                    <b-input v-model.trim="newUnableToShipReason.description" placeholder="Voer een reden in" size="sm" :disabled="disabled"
                             style="width:calc(100% - 20px);margin-left:18px;" :class="{'border-warning': newUnableToShipReason.description.length}"
                             @blur="addReason"
                    />
                </form>
            </b-col>
            <b-col cols="2">
                <b-checkbox switch v-model="newUnableToShipReason.isAutoReassignable" size="lg"/>
            </b-col>
            <b-col cols="1">
                <b-button @click="addReason" variant="primary" v-b-tooltip="`Toevoegen`" size="sm">+</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import _ from "lodash";

export default {
    name: "UnableToShipReasons",
    components: { Draggable },

    props: {
        value: {required: true},
        parameter: {required: true },
        disabled: {default: false },
    },

    data() {
        return {
            internalValue: [],
            unableToShipReasonTemplate: {
                description: '',
                isAutoReassignable: false,
            },
            newUnableToShipReason: {
                description: '',
                isAutoReassignable: false,
            },
            randomGroupId: Date.now(),
            debounceAddReason: _.debounce(this.addReason, 1500)
        }
    },

    mounted() {
        this.internalValue = this.value
        this.newUnableToShipReason = structuredClone(this.unableToShipReasonTemplate)
    },

    computed: {

    },

    methods: {
        addReason() {
            if (!this.newUnableToShipReason.description.length) {
                return
            }

            this.value.push(this.newUnableToShipReason)
            this.newUnableToShipReason = structuredClone(this.unableToShipReasonTemplate)
        },
        removeReason(index) {
            this.value.splice(index, 1)
        },
    },
}
</script>

<style scoped>
.draggable-icon {
    cursor: grab;
}
</style>
